import { liveStream } from "@/mocks/gossip";

const tracks = [
  { t: "沈屿 · 融资明细口径", sub: "3 条新证据待核对", pct: 76 },
  { t: "郑迟 · 分红比例争议", sub: "已进入书面回应阶段", pct: 88 },
  { t: "祁梵 · 代言边界对照", sub: "时间线整理至第 4 天", pct: 64 },
];

const fieldColor: Record<string, string> = {
  文娱: "bg-primary-100 text-primary-800",
  财经: "bg-secondary-100 text-secondary-900",
  社媒: "bg-accent-100 text-accent-800",
};

export default function Stream() {
  return (
    <section id="stream" className="border-b border-foreground-950/10">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3 lg:gap-10">
          {/* timeline feed */}
          <div className="lg:col-span-2">
            <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
              <div className="flex items-center gap-3">
                <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-foreground-950 text-background-50">
                  <i className="ri-chat-history-line" />
                </span>
                <div>
                  <h2 className="font-heading text-xl font-black tracking-tight text-foreground-950 md:text-2xl">今日快讯流</h2>
                  <p className="text-xs text-foreground-500">按时间先后排出「卷入—回应—演变」的关键时点</p>
                </div>
              </div>
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs text-primary-700">
                <span className="h-1.5 w-1.5 rounded-full bg-primary-500 live-dot" /> 正在更新 · {liveStream.length} 条
              </span>
            </div>

            <ol className="relative space-y-0 border-l border-foreground-950/10 pl-5 md:pl-7">
              {liveStream.map((it) => (
                <li key={it.time} className="relative pb-6 last:pb-0">
                  <span className="absolute -left-[26px] top-1.5 h-3 w-3 rounded-full border-2 border-primary-500 bg-background-50 md:-left-[35px] md:h-3.5 md:w-3.5" />
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="font-label text-xs font-semibold text-foreground-950">{it.time}</span>
                    <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-sm bg-primary-600 px-2 py-0.5 text-[11px] font-medium text-background-50">
                      {it.label}
                    </span>
                    <span className={`inline-flex whitespace-nowrap rounded-sm px-2 py-0.5 text-[11px] font-medium ${fieldColor[it.field] ?? "bg-secondary-100 text-secondary-900"}`}>
                      {it.field}
                    </span>
                    <span className="whitespace-nowrap rounded-full bg-background-200 px-2 py-0.5 text-[11px] text-foreground-600">{it.tag}</span>
                  </div>
                  <p className="mt-2 max-w-3xl text-sm leading-relaxed text-foreground-700 md:text-[15px]">{it.text}</p>
                </li>
              ))}
            </ol>

            <div className="mt-5 flex items-center gap-3">
              <a href="#rank" className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-foreground-950/15 px-4 py-2 text-sm text-foreground-800 hover:border-primary-500 hover:text-primary-700">
                更多往期快讯 <i className="ri-arrow-right-line" />
              </a>
              <span className="hidden text-xs text-foreground-500 sm:inline">刷新即视需求而定，不做下拉无限加载</span>
            </div>
          </div>

          {/* tracking watchlist */}
          <aside className="lg:sticky lg:top-32 lg:self-start">
            <div className="rounded-lg border border-foreground-950/10 bg-background-100 p-4 md:p-5">
              <div className="mb-4 flex items-center justify-between">
                <h3 className="font-heading text-base font-bold text-foreground-950">实时追踪主线</h3>
                <span className="inline-flex items-center gap-1 whitespace-nowrap text-[11px] text-foreground-500">
                  <i className="ri-focus-3-line" /> 3 条进行中
                </span>
              </div>
              <ul className="space-y-4">
                {tracks.map((tr, i) => (
                  <li key={tr.t} className="rounded-md bg-background-50 p-3">
                    <div className="flex items-center justify-between gap-2">
                      <span className="font-heading text-sm font-bold text-foreground-950">{i + 1}. {tr.t}</span>
                    </div>
                    <p className="mt-1 text-xs text-foreground-600">{tr.sub}</p>
                    <div className="mt-2 h-1 w-full overflow-hidden rounded-full bg-background-200">
                      <div className="h-full rounded-full bg-accent-500" style={{ width: `${tr.pct}%` }} />
                    </div>
                  </li>
                ))}
              </ul>
              <button type="button" className="mt-4 w-full whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-4 py-2 text-sm font-medium text-primary-800 hover:bg-primary-50">
                <i className="ri-add-line mr-1" /> 添加一条追踪
              </button>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}